interface FormatConfig {
	lovType?: string,															// 值列表类型
	lovTypeFunc?: (data: { row: any, rowIndex: number }) => string,				// 动态值列表类型，根据行记录计算
	parentLovType?: string,														// 父值列表类型
	parentLovValue?: string,													// 父值列表的值
	parentLovValueField?: string,												// 复制列表的值所存在的字段，有的话就会从行记录中获取这个值，优先级比props.parentLovValue高
	excludeLov?: string[],														// 排除的值列表
	$lov: any,																	// 值列表服务对象
	row: any,																	// 当前行对象，可能是编辑行（只要行处于编辑状态，lov是否可编辑），可能是原始行
	rowIndex: number,															// 行索引
	autoMulti?: boolean,														// 是否自动对多值字串进行转换
	val?: string | string[],													// 值
}

/**
 * 格式化显示值列表文本
 * @author  韦胜健
 * @date    2021/7/2 12:43
 */
export async function formatLovString(
	{
		lovType,
		lovTypeFunc,
		parentLovType,
		parentLovValue,
		parentLovValueField,
		excludeLov,
		$lov,
		row,
		rowIndex,
		autoMulti,
		val,
	}: FormatConfig) {

	/*没有值，不渲染任何内容*/
	if (val == null) {return null}

	if (!!lovTypeFunc) {
		lovType = lovTypeFunc({row, rowIndex})
	}
	if (!!parentLovValueField) {
		parentLovValue = row[parentLovValueField]
	}
	const {lovs} = await $lov.getLovData(lovType, parentLovType, parentLovValue, excludeLov) as { lovs?: { val: string, name: string }[] }
	if (!lovs) {return null}

	/*自动解析多值的值列表*/
	if (autoMulti && typeof val === "string") {
		if (val[0] === '[' && val.slice(-1) === ']') {
			/*如果是json字符串，解析json字符串为字符串数组*/
			val = JSON.parse(val) as string[]
		} else if (val.indexOf(',') > -1) {
			/*如果是以逗号为分隔的字符串，分割为字符串数组*/
			val = val.split(',')
		}
	}

	if (!Array.isArray(val)) {
		const lov = lovs.find(i => i.val === val)
		return !lov ? null : lov.name
	} else {
		return val.map(val => {
			const lov = lovs.find(i => i.val === val)
			return !lov ? null : lov.name
		})
	}
}
